import React from 'react';
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltUp, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { ColorPalette } from '../config';
import { Tooltip } from '../tooltip';

export interface IChatSendButtonProps {
  isSending: boolean;
  disabled: boolean;
  onClick: () => void;
}

export function ChatSendButton(props: IChatSendButtonProps) {
  const { isSending, disabled, onClick } = props;

  return (
    <Tooltip title="Send">
      <span>
        <Button
          variant="contained"
          disabled={disabled}
          aria-label="Send"
          sx={{ minWidth: 20, backgroundColor: ColorPalette.PrimaryMain, color: ColorPalette.WHITE, height: 45, width: 45, m: 1 }}
          onClick={onClick}
          size="medium"
        >
          <FontAwesomeIcon icon={isSending ? faSpinner : faArrowAltUp} size="xl" spin={isSending} />
        </Button>
      </span>
    </Tooltip>
  );
}
